import { getSeaLinkBasename } from 'utils/helpers';

function NoActiveBooking() {
  const basename = getSeaLinkBasename();

  return (
    <>
      <div className="mb-4">
        <h2>No active booking</h2>
      </div>
      <div className="mb-4">
        <p>You&apos;ve landed on this page without an active booking.</p>
      </div>
      <a className="btn btn-primary" href={`/${basename}/`}>
        Return to homepage
      </a>
    </>
  );
}

export default NoActiveBooking;
